import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/styles";
import classNames from "classnames";
import styles from "../styles/main";
import LiveContainer from "../containers/live/live";
import BoxTitle from "../components/boxTitle";
import InboxContainer from "../containers/inbox/inboxList";
import { unixToTime } from "../helpers/unix";
import ReconnectingWebSocket from "reconnecting-websocket";
import { getStats } from "../services/stats";
import { getServer, getSettings } from "../services/settings";
import { APP_MODE, APP_MODES } from "../constants/settings";
import { plateLetters, getPlatePersianLetter } from "../constants/plateLetters";
import { withSnackbar } from "notistack";
import { showInfo, showError } from "../helpers/notification";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PurchasesContainer from "../containers/report/purchases";
import RepliesContainer from "../containers/report/replies";
import PopularInstrumentsContainer from "../containers/report/popularInstruments";
import WarrantsContainer from "../containers/warrant/warrants";
import AssembliesContainer from "../containers/assembly/assemblies";

class Data extends Component {
  state = {
    value: 1,
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
        <Grid container justify="center">
          <Grid item>
            <Tabs
              value={value}
              onChange={this.handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="مجمع" />
              <Tab label="حق تقدم" />
            </Tabs>
          </Grid>
        </Grid>

        <br />

        {value == 1 && <WarrantsContainer stats={this.state.stats} />}
        {value == 0 && <AssembliesContainer stats={this.state.stats} />}
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(Data));
